import React from "react";
import { useNavigate } from "react-router-dom";
import { FiStar } from "react-icons/fi";
import profile from "../image/profile.png";
import patternImage from "../image/landing/designer/bg-patterns.webp";
import "./Testimonial.css";

const testimonials = [
  {
    name: "Hannah R.",
    role: "Memory Artist",
    quote:
      "I linked my anniversary tattoo to a private video. The scan is fast, the story feels personal, and switching content is seamless.",
  },
  {
    name: "Marcus L.",
    role: "Creative Director",
    quote:
      "I wanted one tattoo that could evolve with my life. TattQR gave me exactly that without making me re-ink anything.",
  },
  {
    name: "Sofia P.",
    role: "Founder",
    quote:
      "The temporary content feature was perfect for our event launch, then I switched back to my permanent gallery instantly.",
  },
  {
    name: "Daniel K.",
    role: "Musician",
    quote:
      "My tattoo now links to an unreleased track. Fans love the experience, and I can update audio whenever I drop new work.",
  },
  {
    name: "Leah M.",
    role: "Photographer",
    quote:
      "I use one QR tattoo for rotating portfolios. It finally feels like my art can breathe beyond static ink.",
  },
  {
    name: "Noah J.",
    role: "Storyteller",
    quote:
      "I keep family memories PIN-protected. It is simple privacy, exactly enough for sharing only with people I trust.",
  },
];

const Testimonial = () => {
  const navigate = useNavigate();

  return (
    <section
      className="testimonials-page"
      style={{ "--testimonials-pattern-image": `url(${patternImage})` }}
    >
      <div className="testimonials-shell">
        <p className="testimonials-kicker">Testimonials</p>
        <h1>A New Era Of Storytelling</h1>
        <p className="testimonials-lead">
          Real voices from people who transformed their tattoos into living,
          scannable memory experiences.
        </p>

        <div className="testimonials-grid">
          {testimonials.map((item) => (
            <article key={item.name} className="testimonials-card">
              <div className="testimonials-stars">
                {[1, 2, 3, 4, 5].map((star) => (
                  <FiStar key={`${item.name}-${star}`} />
                ))}
              </div>
              <p>&ldquo;{item.quote}&rdquo;</p>
              <div className="testimonials-meta">
                <img src={profile} alt={`${item.name} avatar`} />
                <div>
                  <h3>{item.name}</h3>
                  <small>{item.role}</small>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="testimonials-actions">
          <button type="button" onClick={() => navigate("/signup")}>
            Create My QR Story
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
